module.exports = __webpack_public_path__ + "static/media/101-4.827d3541.jpg";